<section id="profile-info">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group mb-2">
                            <div class="card">
                                <div class="card-header">
                                    <h2>FAQs</h2>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <small>Question</small>
                                                <input class="form-control" [(ngModel)]="question"/>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <small>Answer</small>
                                                <textarea class="form-control" rows="3" [(ngModel)]="answer"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-primary pull-right" rippleEffect
                                            (click)="addDetail()" [disabled]="submitting">
                                        <span class="font-weight-bold">Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card">
                            <div class="card-body">
                                <table class="table table-list">
                                    <thead>
                                    <tr>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Question</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Answer</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody *ngIf="faqs && faqs.length > 0; else noDataToShowWeb">
                                    <tr *ngFor="let faq of faqs">
                                        <td class="text-center">
                                            <h6 class="mt-1">{{faq?.question}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <h6 class="mt-1">{{faq?.answer}}</h6>
                                        </td>
                                        <td class="text-center">
                                            <i class="fas fa-trash font-small-4 text-danger cursor-pointer"
                                               (click)="delete(faq.id)"></i>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <ng-template #noDataToShowWeb>
                                        <tbody>
                                        <tr>
                                            <td class="text-center" colspan="3">
                                                <h6 class="mt-1">No data to show</h6>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </ng-template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
